import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "./components/ui/sonner";
import { AuthProvider, useAuth } from "./contexts/AuthContext";
import Login from "./pages/Login";
import ForgotPassword from "./pages/ForgotPassword";
import ResetPassword from "./pages/ResetPassword";
import Dashboard from "./pages/Dashboard";
import Clients from "./pages/Clients";
import Suppliers from "./pages/Suppliers";
import Products from "./pages/Products";
import Orders from "./pages/Orders";
import Sales from "./pages/Sales";
import PDV from "./pages/PDV";
import Purchases from "./pages/Purchases";
import Reports from "./pages/Reports";
import Settings from "./pages/Settings";
import Sellers from "./pages/Sellers";
import Commissions from "./pages/Commissions";
import CashClosing from "./pages/CashClosing";
import Returns from "./pages/Returns";
import ImportData from "./pages/ImportData";
import NFCeConfig from "./pages/NFCeConfig";
import Empresas from "./pages/Empresas";
import StockControl from "./pages/StockControl";
import Layout from "./components/Layout";
import { ErrorBoundary } from "./components/ErrorBoundary";
import "./App.css";

const PrivateRoute = ({ children }) => {
  const { user, loading } = useAuth();
  
  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-slate-50">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600"></div>
      </div>
    );
  }
  
  return user ? children : <Navigate to="/login" />;
};

const AdminRoute = ({ children }) => {
  const { user, loading } = useAuth();
  
  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-slate-50">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600"></div>
      </div>
    );
  }
  
  if (!user) return <Navigate to="/login" />;
  if (user.role === 'vendedor') return <Navigate to="/dashboard" />;
  return children;
};

function App() {
  return (
    <ErrorBoundary>
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route path="/reset-password" element={<ResetPassword />} />
          <Route path="/" element={
            <PrivateRoute>
              <Layout />
            </PrivateRoute>
          }>
            <Route index element={<Dashboard />} />
            <Route path="dashboard" element={<Dashboard />} />
            <Route path="pdv" element={<AdminRoute><PDV /></AdminRoute>} />
            <Route path="clientes" element={<Clients />} />
            <Route path="fornecedores" element={<AdminRoute><Suppliers /></AdminRoute>} />
            <Route path="produtos" element={<Products />} />
            <Route path="entradas" element={<AdminRoute><Purchases /></AdminRoute>} />
            <Route path="pedidos" element={<Orders />} />
            <Route path="vendas" element={<Sales />} />
            <Route path="devolucoes" element={<Returns />} />
            <Route path="vendedores" element={<Sellers />} />
            <Route path="comissoes" element={<Commissions />} />
            <Route path="fechamento" element={<AdminRoute><CashClosing /></AdminRoute>} />
            <Route path="estoque" element={<StockControl />} />
            <Route path="importar" element={<AdminRoute><ImportData /></AdminRoute>} />
            <Route path="nfce" element={<AdminRoute><NFCeConfig /></AdminRoute>} />
            <Route path="empresas" element={<Empresas />} />
            <Route path="relatorios" element={<Reports />} />
            <Route path="configuracoes" element={<Settings />} />
          </Route>
        </Routes>
        <Toaster position="top-right" richColors />
      </BrowserRouter>
    </AuthProvider>
    </ErrorBoundary>
  );
}

export default App;
